/* pim-rm-configurator.js — Power In Motion / Riese & Müller build configurator.
 *
 * One Shopify product per series. This turns its description into a picker for
 * model (trim) + every factory option, with a running total that matches R&M's
 * own site, and replaces the theme's Add to cart with a Call to Order.
 *
 * Upload this, pim-rm-configurator.css and pim-rm-bikes.json to Shopify >
 * Themes > Edit code > Assets. Product descriptions only contain
 *     <div class="pim-rm-config" data-series="riese-muller-charger5"></div>
 * so prices change by re-uploading pim-rm-bikes.json alone.
 *
 * Generated by R-M Bike Sync. Re-upload rather than hand-editing.
 */
(function () {
  "use strict";

  var SELF = document.currentScript && document.currentScript.src;

  /* The Call/Email block sits outside the configurator, so it needs a way to
   * read the build the customer has actually configured. build() publishes it
   * here and the buttons read it at click time, not at render time. */
  var currentBuild = null;

  /* Nothing tells a page whether mailto: actually opened anything - there is no
   * event either way. The one reliable signal is that launching a mail client
   * pulls focus away from the page. So: try it, and if focus never leaves
   * within about a second, assume nothing happened and show the message on
   * screen instead so the customer can copy it. A late-firing timer means the
   * tab WAS backgrounded (throttled), which counts as success. */
  function openMail(meta) {
    var href = mailtoFor(meta);
    if (!href) { showMailFallback(meta); return; }

    var left = false;
    function mark() { left = true; }
    window.addEventListener("blur", mark);
    document.addEventListener("visibilitychange", mark);

    var started = Date.now();
    try {
      window.location.href = href;
    } catch (e) {
      showMailFallback(meta);
      return;
    }

    setTimeout(function () {
      window.removeEventListener("blur", mark);
      document.removeEventListener("visibilitychange", mark);
      var elapsed = Date.now() - started;
      if (!left && document.visibilityState === "visible" && elapsed < 2500) {
        showMailFallback(meta);
      }
    }, 1100);
  }

  function showMailFallback(meta) {
    var existing = document.querySelector(".pim-rm-modal");
    if (existing) existing.remove();

    var to = meta.email || "";
    var subject = currentBuild ? currentBuild.subject() : "";
    var message = currentBuild ? currentBuild.message() : "";

    var wrap = el("div", "pim-rm-modal");
    wrap.setAttribute("role", "dialog");
    wrap.setAttribute("aria-modal", "true");
    wrap.setAttribute("aria-label", "Send your build by email");

    var card = el("div", "pim-rm-modal__card");
    card.appendChild(el("h3", "pim-rm-modal__title", "Send us your build"));
    card.appendChild(el("p", "pim-rm-modal__lead",
      "We could not open an email app on this device. Copy the message below " +
      "and send it to us — everything you picked is already in it."));

    var addr = el("p", "pim-rm-modal__to");
    addr.appendChild(el("span", null, "Email it to "));
    var link = el("a", null, to || "the shop");
    link.href = "mailto:" + to;
    addr.appendChild(link);
    card.appendChild(addr);

    var box = el("textarea", "pim-rm-modal__text");
    box.readOnly = true;
    box.value = "Subject: " + subject + "\n\n" + message;
    box.rows = 14;
    card.appendChild(box);

    var actions = el("div", "pim-rm-modal__actions");
    var copy = el("button", "pim-rm-cta", "Copy message");
    copy.type = "button";
    copy.addEventListener("click", function () {
      box.select();
      var done = false;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(box.value).then(function () {
          copy.textContent = "Copied";
        }, function () {});
        done = true;
      }
      if (!done) {
        try { document.execCommand("copy"); copy.textContent = "Copied"; } catch (e) {}
      }
      setTimeout(function () { copy.textContent = "Copy message"; }, 1800);
    });
    actions.appendChild(copy);

    if (meta.phone_href) {
      var call = el("a", "pim-rm-cta pim-rm-cta--ghost",
        "Or call " + (meta.phone || ""));
      call.href = "tel:" + meta.phone_href;
      actions.appendChild(call);
    }

    var close = el("button", "pim-rm-cta pim-rm-cta--ghost", "Close");
    close.type = "button";
    close.addEventListener("click", function () { wrap.remove(); });
    actions.appendChild(close);
    card.appendChild(actions);

    wrap.appendChild(card);
    wrap.addEventListener("click", function (e) {
      if (e.target === wrap) wrap.remove();
    });
    document.addEventListener("keydown", function esc(e) {
      if (e.key === "Escape") { wrap.remove(); document.removeEventListener("keydown", esc); }
    });

    document.body.appendChild(wrap);
    // Focus without selecting: select() jumps the textarea to the end, so the
    // customer would open it looking at the signature. Copy does the selecting.
    box.focus();
    box.scrollTop = 0;
    box.setSelectionRange(0, 0);
  }

  function mailtoFor(meta) {
    var to = meta.email || "";
    if (!to) return null;
    var subject = currentBuild ? currentBuild.subject() : "Bike enquiry";
    var body = currentBuild ? currentBuild.message() : "";
    return "mailto:" + to +
      "?subject=" + encodeURIComponent(subject) +
      "&body=" + encodeURIComponent(body);
  }

  /* Hide the theme's buy controls as early as possible, but ONLY on a page that
   * actually carries a configurator. This script is loaded site-wide, so an
   * unconditional class here would blank the Add to cart button on every other
   * product in the store until init() ran. The script is deferred, so the DOM
   * is already parsed and this check is reliable. */
  if (document.documentElement &&
      document.querySelector(".pim-rm-config[data-series]")) {
    document.documentElement.classList.add("pim-rm-quote-only");
  }

  /* :has() covers modern browsers; this tags the same cards for older ones, and
   * additionally marks the ones whose photo is not square. R&M shoot 3:2, which
   * a square card would crop; the shop's own square photos need no padding and
   * are left untouched. */
  function tagBrandCards() {
    var links = document.querySelectorAll('a[href*="/products/riese-muller-"]');
    Array.prototype.forEach.call(links, function (a) {
      var card = a.closest && a.closest(".card-wrapper");
      if (!card) return;
      card.classList.add("pim-rm-card");

      var img = card.querySelector(".card__media img, .media img");
      if (!img) return;
      var check = function () {
        if (!img.naturalWidth || !img.naturalHeight) return;
        var ratio = img.naturalWidth / img.naturalHeight;
        if (Math.abs(ratio - 1) > 0.05) card.classList.add("pim-rm-card--fit");
      };
      if (img.complete) check();
      else img.addEventListener("load", check, { once: true });
    });
  }

  function dataUrl(root) {
    if (root && root.getAttribute("data-src")) return root.getAttribute("data-src");
    if (window.PIM_RM_DATA_URL) return window.PIM_RM_DATA_URL;
    if (SELF) return SELF.replace(/pim-rm-configurator\.js.*$/, "pim-rm-bikes.json");
    return "/assets/pim-rm-bikes.json";
  }

  /* Keep the theme's own price in step with the configured build. The variant
   * picker is hidden, so Shopify would otherwise show the default variant's
   * price no matter what the customer picked. */
  function syncThemePrice(text, caption) {
    var host = document.querySelector(".price__container");
    if (!host) return;
    host.innerHTML = "";
    var span = document.createElement("span");
    span.className = "pim-rm-theme-price";
    span.textContent = text;
    if (caption) {
      var small = document.createElement("small");
      small.textContent = caption;
      span.appendChild(small);
    }
    host.appendChild(span);
  }

  /* ---- drive the theme's own product gallery -------------------------- */
  /* Shopify keeps R&M's filename stem and appends a uuid, so "25_1.jpg" in the
   * configurator matches "25_1_385397cb-....jpg" in the gallery. Colours are
   * real product images and get a proper slide; option close-ups are not
   * uploaded, so for those the active image is swapped in place instead. */
  function fileStem(url) {
    if (!url) return "";
    var file = url.split("/").pop().split("?")[0];
    return file.replace(/\.[a-z0-9]+$/i, "");
  }

  function galleryThumbs() {
    return document.querySelectorAll(
      ".thumbnail-list__item button, .thumbnail-list__item .thumbnail");
  }

  function activeGalleryImage() {
    return document.querySelector(
      ".product__media-item:not(.is-active) ~ .product__media-item.is-active img," +
      " .product__media-item.is-active img, .product__media img");
  }

  function showInGallery(url) {
    var stem = fileStem(url);
    if (!stem) return false;
    var safe = stem.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var re = new RegExp("/" + safe + "[._]");
    var thumbs = galleryThumbs();
    for (var i = 0; i < thumbs.length; i++) {
      var img = thumbs[i].querySelector("img");
      if (!img) continue;
      if (re.test("/" + (img.currentSrc || img.src || "").split("/").pop())) {
        // Dawn scrolls the gallery on activation; keep the page where it was.
        var y = window.scrollY;
        thumbs[i].click();
        restoreMainImage();
        setTimeout(function () { window.scrollTo(0, y); }, 0);
        return true;
      }
    }
    return false;
  }

  function restoreMainImage() {
    var img = activeGalleryImage();
    if (img && img.dataset.pimRmOriginal) {
      img.src = img.dataset.pimRmOriginal;
      if (img.srcset !== undefined) img.srcset = img.dataset.pimRmOriginalSet || "";
      delete img.dataset.pimRmOriginal;
      delete img.dataset.pimRmOriginalSet;
    }
  }

  function swapMainImage(url) {
    var img = activeGalleryImage();
    if (!img || !url) return false;
    if (!img.dataset.pimRmOriginal) {
      img.dataset.pimRmOriginal = img.src;
      img.dataset.pimRmOriginalSet = img.srcset || "";
    }
    img.srcset = "";
    img.src = url;
    return true;
  }

  /* R&M's CDN refuses requests that carry another site's referer (403), so an
   * image still pointing at assets.r-m.de will never render here. Only swap in
   * something we host; anything else leaves the bike photo alone rather than
   * blanking it. */
  function isHosted(url) {
    return /(^\/)|(cdn\.shopify\.com)|(\/cdn\/shop\/)/.test(url || "") ||
           (url || "").indexOf(window.location.host) !== -1;
  }

  function previewInTheme(url) {
    if (!url) return;
    if (showInGallery(url)) return;
    if (isHosted(url)) swapMainImage(url);
    else restoreMainImage();
  }

  function money(n, sym) {
    return sym + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* ---- replace Add to cart with Call to Order ------------------------- */
  function quoteOnly(meta) {
    var form = document.querySelector(
      "product-form, .product-form, form[action*='/cart/add']");
    if (!form || form.dataset.pimRmDone) return;
    form.dataset.pimRmDone = "1";

    var box = el("div", "pim-rm-buy");
    box.appendChild(el("p", "pim-rm-buy__lead",
      "Built to order. We confirm your specification, price and lead time before " +
      "anything is ordered."));

    var row = el("div", "pim-rm-buy__actions");
    if (meta.phone_href) {
      var call = el("a", "pim-rm-cta",
        (meta.cta_label || "Call to Order") + (meta.phone ? " — " + meta.phone : ""));
      call.href = "tel:" + meta.phone_href;
      row.appendChild(call);
    }
    if (meta.email) {
      var mail = el("a", "pim-rm-cta pim-rm-cta--ghost", "Email this build");
      mail.href = "mailto:" + meta.email;
      mail.addEventListener("click", function (e) {
        e.preventDefault();
        openMail(meta);
      });
      row.appendChild(mail);
    }
    if (!row.childNodes.length) {
      row.appendChild(el("strong", null, meta.cta_label || "Call to Order"));
    }
    box.appendChild(row);
    form.parentNode.insertBefore(box, form);
  }

  /* ---- one configurator ----------------------------------------------- */
  function build(root, series, meta) {
    var sym = meta.symbol || "$";
    var trims = series.trims || [];
    if (!trims.length) return;

    var state = { trim: 0, chosen: {} };

    root.innerHTML = "";
    root.classList.add("pim-rm--ready");

    var head = el("div", "pim-rm__head");
    root.appendChild(head);

    var grid = el("div", "pim-rm__grid");
    var left = el("div", "pim-rm__choices");
    var right = el("div", "pim-rm__summary");
    grid.appendChild(left);
    grid.appendChild(right);
    root.appendChild(grid);

    /* model picker */
    var modelGroup = el("div", "pim-rm__group pim-rm__group--models");
    modelGroup.appendChild(el("h4", "pim-rm__feature", "Model"));
    var modelRow = el("div", "pim-rm__models");
    trims.forEach(function (t, i) {
      var b = el("button", "pim-rm__model");
      b.type = "button";
      b.appendChild(el("span", "pim-rm__model-name", t.name));
      b.appendChild(el("span", "pim-rm__model-price", money(t.base || 0, sym)));
      b.addEventListener("click", function () {
        if (state.trim === i) return;
        state.trim = i;
        state.preview = null;
        resetChoices();
        renderOptions();
        render();
      });
      t._btn = b;
      modelRow.appendChild(b);
    });
    modelGroup.appendChild(modelRow);
    head.appendChild(modelGroup);

    var optionsHost = el("div", "pim-rm__options-host");
    left.appendChild(optionsHost);

    function trim() { return trims[state.trim]; }

    function resetChoices() {
      state.chosen = {};
      (trim().features || []).forEach(function (f, i) {
        var def = null;
        (f.options || []).forEach(function (o) { if (o.default) def = o; });
        if (!def && !f.optional && f.options && f.options.length) def = f.options[0];
        state.chosen[i] = def;
      });
    }

    /* "08" and 8 are the same option to R&M, so compare them the same way. */
    function oid(v) {
      var t = String(v == null ? "" : v).replace(/^0+/, "");
      return t === "" ? "0" : t;
    }

    function selectedIds() {
      var ids = [];
      for (var k in state.chosen) if (state.chosen[k]) ids.push(oid(state.chosen[k].id));
      return ids;
    }

    function conflicts(id) {
      var blocked = (trim().blacklist || {})[oid(id)] || [];
      var live = selectedIds();
      for (var i = 0; i < blocked.length; i++) {
        if (live.indexOf(oid(blocked[i])) !== -1) return true;
      }
      return false;
    }

    function total() {
      var t = trim().base || 0;
      for (var k in state.chosen) if (state.chosen[k]) t += (state.chosen[k].price || 0);
      return t;
    }

    /* option groups for the current trim */
    function renderOptions() {
      optionsHost.innerHTML = "";
      var t = trim();

      (t.features || []).forEach(function (f, i) {
        if (!f.selectable) return;
        var group = el("div", "pim-rm__group");
        group.appendChild(el("h4", "pim-rm__feature", f.feature));
        var wrap = el("div", f.colour ? "pim-rm__swatches" : "pim-rm__options");

        var choices = (f.options || []).slice();
        if (f.optional) {
          choices.unshift({ id: "__none__" + i, name: f.default_text || ("No " + f.feature),
                            price: 0, none: true });
        }

        choices.forEach(function (o) {
          var btn = el("button", f.colour ? "pim-rm__swatch" : "pim-rm__option");
          btn.type = "button";
          if (f.colour && o.hex) {
            var dot = el("span", "pim-rm__dot");
            dot.style.background = o.hex;
            btn.appendChild(dot);
          }
          btn.appendChild(el("span", "pim-rm__name", o.name));
          if (!o.none && o.price > 0) {
            btn.appendChild(el("span", "pim-rm__price", "+" + money(o.price, sym)));
          } else if (!f.colour) {
            btn.appendChild(el("span", "pim-rm__price", o.none ? "" : "included"));
          }
          if (o.description) btn.title = o.description;
          if (o.image) btn.classList.add("has-image");
          btn.addEventListener("click", function () {
            if (btn.disabled) return;
            state.chosen[i] = o.none ? null : o;
            // Show what was just picked, if R&M photograph it.
            state.preview = (!o.none && o.image)
              ? { src: o.image, label: f.feature + ": " + o.name }
              : null;
            render();
          });
          o._btn = btn;
          wrap.appendChild(btn);
        });

        f._choices = choices;
        group.appendChild(wrap);
        optionsHost.appendChild(group);
      });

      var fixed = (t.features || []).filter(function (f) { return !f.selectable; });
      if (fixed.length) {
        var fg = el("div", "pim-rm__group pim-rm__group--fixed");
        fg.appendChild(el("h4", "pim-rm__feature", "Included as standard"));
        var ul = el("ul", "pim-rm__fixed");
        fixed.forEach(function (f) {
          (f.options || []).forEach(function (o) {
            ul.appendChild(el("li", null, f.feature + ": " + o.name));
          });
        });
        fg.appendChild(ul);
        optionsHost.appendChild(fg);
      }
    }

    /* summary panel */
    var figureWrap = el("div", "pim-rm__figure");
    var figure = el("img", "pim-rm__image");
    figure.alt = series.name;
    figure.loading = "lazy";
    figure.addEventListener("error", function () { figureWrap.style.display = "none"; });
    figure.addEventListener("load", function () { figureWrap.style.display = ""; });
    var caption = el("span", "pim-rm__caption");
    figureWrap.appendChild(figure);
    figureWrap.appendChild(caption);
    right.appendChild(figureWrap);

    right.appendChild(el("h4", "pim-rm__feature", "Your build"));
    var specList = el("dl", "pim-rm__spec");
    var totalRow = el("div", "pim-rm__total");
    var warn = el("p", "pim-rm__warn");
    var actions = el("div", "pim-rm__actions");
    right.appendChild(specList);
    right.appendChild(totalRow);
    right.appendChild(warn);
    right.appendChild(actions);
    right.appendChild(el("p", "pim-rm__note",
      "Estimate only. Taxes, assembly and delivery are not included — we " +
      "confirm the final quote and lead time when you call."));

    if (meta.phone_href) {
      var call = el("a", "pim-rm-cta",
        (meta.cta_label || "Call to Order") + (meta.phone ? " — " + meta.phone : ""));
      call.href = "tel:" + meta.phone_href;
      actions.appendChild(call);
    }
    if (meta.email) {
      var mail = el("a", "pim-rm-cta pim-rm-cta--ghost", "Email this build");
      mail.href = "#";
      mail.addEventListener("click", function (e) {
        e.preventDefault();
        openMail(meta);
      });
      actions.appendChild(mail);
    }
    var copy = el("button", "pim-rm-cta pim-rm-cta--ghost", "Copy this build");
    copy.type = "button";
    copy.addEventListener("click", function () {
      var text = specText();
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function () {
        copy.textContent = "Copied";
        setTimeout(function () { copy.textContent = "Copy this build"; }, 1800);
      });
    });
    actions.appendChild(copy);

    function fullName() {
      var brand = meta.brand ? meta.brand + " " : "";
      return brand + series.name;
    }

    function emailSubject() {
      return fullName() + " " + trim().name + " - build enquiry";
    }

    function emailMessage() {
      var t = trim();
      var who = meta.store_name || "there";
      var lines = [];
      lines.push("Hi " + who + ",");
      lines.push("");
      lines.push("I'm looking at the " + fullName() + " (" + t.name +
                 ") and I've set it up like this:");
      lines.push("");
      lines.push("  Model: " + t.name + " - " + money(t.base || 0, sym));
      (t.features || []).forEach(function (f, i) {
        var o = state.chosen[i];
        if (!o) return;
        lines.push("  " + f.feature + ": " + o.name +
                   (o.price > 0 ? " (+" + money(o.price, sym) + ")" : ""));
      });
      lines.push("");
      lines.push("Estimated total: " + money(total(), sym) + " " + (meta.currency || ""));
      lines.push("");
      lines.push("Could you confirm availability, lead time and the final price?");
      lines.push("");
      lines.push("Thanks,");
      lines.push("");
      // The page they are on is far more use to the shop than R&M's own URL.
      var ref = (window.location && window.location.href) || t.url;
      if (ref) {
        lines.push("(From: " + ref.split("#")[0] + ")");
      }
      return lines.join("\n");
    }

    currentBuild = { subject: emailSubject, message: emailMessage };

    function specText() {
      var t = trim();
      var lines = [series.name + " " + t.name, ""];
      (t.features || []).forEach(function (f, i) {
        var o = state.chosen[i];
        if (!o) return;
        lines.push("  " + f.feature + ": " + o.name +
                   (o.price > 0 ? "  (+" + money(o.price, sym) + ")" : ""));
      });
      lines.push("", "Model price: " + money(t.base || 0, sym));
      lines.push("Total: " + money(total(), sym) + " " + (meta.currency || ""));
      if (t.url) lines.push("", "Reference: " + t.url);
      return lines.join("\n");
    }

    function render() {
      var t = trim();

      trims.forEach(function (x, i) {
        x._btn.classList.toggle("is-active", i === state.trim);
      });

      (t.features || []).forEach(function (f, i) {
        if (!f._choices) return;
        f._choices.forEach(function (o) {
          if (!o._btn) return;
          var active = o.none ? state.chosen[i] === null : state.chosen[i] === o;
          o._btn.classList.toggle("is-active", !!active);
          var bad = !o.none && !active && conflicts(o.id);
          o._btn.disabled = bad;
          o._btn.classList.toggle("is-blocked", bad);
        });
      });

      specList.innerHTML = "";
      var dt = el("dt", null, "Model");
      var dd = el("dd", null, t.name + "  " + money(t.base || 0, sym));
      specList.appendChild(dt); specList.appendChild(dd);
      (t.features || []).forEach(function (f, i) {
        var o = state.chosen[i];
        if (!o) return;
        specList.appendChild(el("dt", null, f.feature));
        specList.appendChild(el("dd", null,
          o.name + (o.price > 0 ? "  +" + money(o.price, sym) : "")));
      });

      totalRow.innerHTML = "";
      totalRow.appendChild(el("span", "pim-rm__total-label", "Estimated total"));
      totalRow.appendChild(el("span", "pim-rm__total-value",
        money(total(), sym) + " " + (meta.currency || "")));

      var blocked = [];
      (t.features || []).forEach(function (f) {
        if (!f._choices) return;
        f._choices.forEach(function (o) {
          if (o._btn && o._btn.disabled) blocked.push(o.name);
        });
      });
      syncThemePrice(money(total(), sym) + " " + (meta.currency || ""),
                     series.name + " " + t.name);

      warn.textContent = blocked.length
        ? "Not available with your current selection: " + blocked.join(", ") + "."
        : "";
      warn.style.display = blocked.length ? "" : "none";

      // Priority: the option just clicked, else the chosen colour, else stock.
      var img = t.image, label = t.name;
      for (var k in state.chosen) {
        var o = state.chosen[k];
        if (o && o.image && (t.features[k] || {}).colour) {
          img = o.image; label = o.name; break;
        }
      }
      if (state.preview) { img = state.preview.src; label = state.preview.label; }
      if (img) {
        figureWrap.style.display = "";
        // The gallery is matched on filename, so it always gets the real URL -
        // that is what makes colour swatches work. Only the small preview needs
        // a URL the browser can actually fetch.
        figure.src = isHosted(img) ? img : (t.image || "");
        caption.textContent = label || "";
        previewInTheme(img);
      } else {
        figureWrap.style.display = "none";
      }
    }

    resetChoices();
    renderOptions();
    render();
  }

  /* ---- boot ----------------------------------------------------------- */
  /* Product-tab apps copy the description into a second container, so the same
   * configurator can appear more than once. Build one per series, preferring a
   * visible copy, and blank the rest - two live copies would both write to the
   * theme's price element and disagree with each other. */
  function pickRoots(all) {
    var chosen = {};
    Array.prototype.forEach.call(all, function (root) {
      var key = root.getAttribute("data-series");
      var current = chosen[key];
      if (!current || (current.offsetParent === null && root.offsetParent !== null)) {
        chosen[key] = root;
      }
    });
    var keep = [];
    for (var k in chosen) keep.push(chosen[k]);
    Array.prototype.forEach.call(all, function (root) {
      if (keep.indexOf(root) === -1) {
        root.innerHTML = "";
        root.setAttribute("data-pim-rm-duplicate", "1");
      }
    });
    return keep;
  }

  function apply(data) {
    var all = document.querySelectorAll(".pim-rm-config[data-series]");
    if (!all.length) return;
    var meta = data.meta || {};
    pickRoots(all).forEach(function (root) {
      var series = (data.series || {})[root.getAttribute("data-series")];
      if (series) build(root, series, meta);
    });
    quoteOnly(meta);
  }

  function init() {
    tagBrandCards();
    var roots = document.querySelectorAll(".pim-rm-config[data-series]");
    if (!roots.length) {
      // Not an R&M product - put the theme's buy buttons back.
      document.documentElement.classList.remove("pim-rm-quote-only");
      return;
    }
    if (window.PIM_RM_DATA && window.PIM_RM_DATA.series) { apply(window.PIM_RM_DATA); return; }

    // cache: "no-cache" forces a revalidation with Shopify on every load.
    // The derived JSON URL carries no ?v= cache-buster (Shopify only versions
    // the URLs Liquid emits), so without this the browser would keep serving a
    // stale copy and a price re-upload would never reach customers. A 304 is
    // cheap; only a genuinely changed file is downloaded again.
    fetch(dataUrl(roots[0]), { credentials: "omit", cache: "no-cache" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) { window.PIM_RM_DATA = data; apply(data); })
      .catch(function (err) {
        // Leave the static tables visible and restore the theme's own buttons,
        // so the page is never left with no way to buy or enquire.
        document.documentElement.classList.remove("pim-rm-quote-only");
        if (window.console) console.warn("[pim-rm] configurator data unavailable:", err);
      });
  }

  /* `build()` exposes what the customer has configured - handy for support
   * ("read me back what you picked") and for checking the email template. */
  window.PIM_RM = {
    init: init,
    refresh: init,
    build: function () {
      if (!currentBuild) return null;
      return { subject: currentBuild.subject(), message: currentBuild.message() };
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
